export default {
  // 移动端分页样式适配
  mobilePage() {
    // 判断设备尺寸-调整分页样式
    let data = {
      
      countPager: 0,
      
    }
    if (document.body.clientWidth <= 640) {
      
     
      data.countPager = 5;
    } else {
      
      data.countPager = 9;
    }
    return data
  }
}